module.exports = __webpack_public_path__ + "img/ios.5cd264d8.png";